export const createFlattenedFormItemsArray = (formItems: any[]): any[] => {
  const flattenArray: any[] = [];
  formItems.forEach((item) => flattenNode(item, flattenArray));
  return flattenArray;
};

const flattenNode = (node: any, result: any[]): void => {
  // Sections
  if (Array.isArray(node)) {
    node.forEach((child) => flattenNode(child, result));
    return;
  }
  // Section or group - recursion into items
  if (node?.type === 'section' || node?.type === 'group') {
    const items = node.items;
    const list = Array.isArray(items)
      ? items
      : Array.from(items?.values() ?? []);
    list.forEach((child) => flattenNode(child, result));
    return;
  }
  // Regular form item
  result.push(node);
};
